export default "/images/vendor/flag-icon-css/flags/1x1/id.svg?b8cee6f6cd34c5dc424927a92a1ee8b2";